import './index.css';
import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import { sanitizeHTML } from '../SanitizedHTML';

const Typewriter = dynamic(() => import('typewriter-effect'), { ssr: false });

const TypewriterComponent = ({
  htmlString,
  runAnimation,
  onFinished,
  showFull,
}: {
  htmlString: string;
  runAnimation: boolean;
  showFull?: boolean;
  onFinished?: () => void;
}) => {
  const [run, setRun] = useState<boolean>(runAnimation);
  const typewriterRef = useRef<any>(null);
  let decodedHTML = sanitizeHTML(htmlString);

  useEffect(() => {
    if (showFull) {
      if (typewriterRef.current?.stop) {
        try {
          typewriterRef.current.stop();
        } catch (err) {
          console.log(err);
        }
      }
      typewriterRef.current?.callFunction(() => {
        onFinished && onFinished();
      });
    }
  }, [showFull, onFinished]);

  useEffect(() => {
    if (run && typewriterRef.current) {
      // replace & symbol that is not properly typed by the typewriter
      decodedHTML = decodedHTML.replaceAll('&amp;', 'and');

      typewriterRef.current
        .typeString(decodedHTML)
        .callFunction(() => {
          onFinished && onFinished();
        })
        .start();
    }
  }, [run, htmlString]);

  useEffect(() => {
    if (run !== runAnimation) {
      setRun(runAnimation);
    }
  }, [runAnimation]);

  if (showFull) {
    return (
      <div
        className="displayed-html"
        dangerouslySetInnerHTML={{ __html: decodedHTML }}
      />
    );
  }

  return (
    <>
      <Typewriter
        options={{
          wrapperClassName: 'displayed-html',
          autoStart: false,
          delay: 0.8,
        }}
        onInit={(typewriter) => {
          typewriterRef.current = typewriter;
        }}
      />
    </>
  );
};

export default TypewriterComponent;
